<template>
  <div>
    我的积分
  </div>
</template>

<script setup lang="ts">

</script>